module.exports = __webpack_public_path__ + "img/login-johnfkennedy.1900f709.svg";